export default __webpack_public_path__ + "static/media/newRedArrow.37364cfd.svg";